<template>
  <div class="navbar">
    <div class="left-title">
      <img
        class="logo"
        src="../../../assets/ZoomLogo.png"
      >
      AsyncMQ
    </div>
    <div class="right-menu">
      <zm-dropdown
        v-if="domainList && domainList.length"
        @command="handleSwitchDc"
        trigger="click"
      >
        <div class="zm-dropdown-link">
          {{currentDomain}}
          <i class="zm-icon-down zm-icon--right"></i>
        </div>
        <zm-dropdown-menu slot="dropdown">
          <zm-dropdown-item
            v-for="item in domainList"
            :key="item.id"
            :command="item"
          >
            {{ item }}
          </zm-dropdown-item>
          <!-- <zm-dropdown-item command="http://localhost:8082/">
            http://localhost:8082/
          </zm-dropdown-item> -->
        </zm-dropdown-menu>
      </zm-dropdown>
      <SystermNews></SystermNews>
      <zm-dropdown
        @command="handleCommand"
        trigger="click"
      >
        <zm-avatar
          size="medium"
          class="mgr-md"
        >
          <div style="font-size: 21px;">{{username.charAt(0).toLocaleUpperCase()}}</div>
        </zm-avatar>
        <zm-dropdown-menu
          slot="dropdown"
          :hide-timeout="350"
          class="user-center-popver"
        >
          <zm-dropdown-item class="user-name">
            Hi, {{ username }}
          </zm-dropdown-item>
          <zm-dropdown-item command="logout">Log Out
          </zm-dropdown-item>
          <zm-dropdown-item
            command="exportTooltip"
            v-if="isAdmin"
          >Export Tooltip
          </zm-dropdown-item>
          <zm-dropdown-item
            command="importTooltip"
            v-if="isAdmin"
          >Import Tooltip
          </zm-dropdown-item>
          <zm-popover
            v-if="versionInfo"
            placement="left-start"
            width="400"
            trigger="hover"
            popper-class="version-display-popper"
            :content="versionInfo"
          >
            <zm-dropdown-item slot="reference">Version</zm-dropdown-item>
          </zm-popover>
          <zm-dropdown-item command="openChangeLog">Change log
          </zm-dropdown-item>
        </zm-dropdown-menu>
      </zm-dropdown>
    </div>
    <zm-dialog
      :title="title"
      :visible.sync="visible"
      append-to-body
    >
      <zm-form>
        <zm-form-item>
          <zm-input
            type="textarea"
            v-model="tipData"
          ></zm-input>
        </zm-form-item>
      </zm-form>
      <div slot="footer">
        <zm-button
          size="small"
          @click="visible = false"
        >Cancel</zm-button>
        <zm-button
          size="small"
          type="primary"
          @click="importTooltip()"
        >Submit</zm-button>
      </div>
    </zm-dialog>
    <zm-dialog
      title="Change Log"
      :visible.sync="changeLogVisible"
      append-to-body
      show-close
    >
      <ChangeLog readonly></ChangeLog>
    </zm-dialog>
  </div>
</template>
<script>
import { getDc, version } from '@/api/index'
import {
  listTooltip,
  batchCreateTooltip
} from '@/api/tip'
import ChangeLog from '@/components/changeLog.vue'
import SystermNews from './systermNews.vue'
import AES from 'crypto-js/aes'
export default {
  components: {
    ChangeLog,
    SystermNews
  },
  data () {
    return {
      isAdmin: localStorage.role === 'SUPER_ADMIN',
      visible: false,
      title: '',
      tipData: '',
      username: localStorage.username,
      versionInfo: '',
      changeLogVisible: false,
      domainList: [],
      currentDomain: ''
    }
  },
  created () {
    this.fetchDC()
    version().then(data => {
      this.versionInfo = data
    })
  },
  methods: {
    fetchDC () {
      getDc(false, false).then(response => {
        let domains = response.map(item => {
          if (item.endpoint.includes('https://')) {
            return item.endpoint.split('https://')?.[1] || item.endpoint
          }
          return item.endpoint
        })
        const set = new Set(domains)
        domains = Array.from(set)
        this.domainList = domains || []
        this.currentDomain = 'Toggle Domain'
      })
    },
    handleSwitchDc (command) {
      this.currentDomain = command
      const mqinfo = {
        mqrefreshtoken: localStorage.refreshToken,
        mqtoken: localStorage.token,
        username: localStorage.username,
        role: localStorage.role,
        mqval: 'shjvfsjvjdfv'
      }
      window.location.href = 'https://' + command + '#' + this.$route.path + '?dclogin=' + AES.encrypt(JSON.stringify(mqinfo), 'abc13scfssawdecsd').toString()
    },
    handleCommand (command) {
      if (command === 'logout') {
        this.logout()
      } else if (command === 'exportTooltip') {
        this.exportTooltip()
      } else if (command === 'importTooltip') {
        this.showImport()
      } else if (command === 'openChangeLog') {
        this.openChangeLog()
      }
    },
    logout () {
      localStorage.setItem('token', '')
      this.$router.replace('/login')
      // location.reload()
    },
    showImport () {
      this.title = 'Import Tooltip'
      this.visible = true
      this.tipData = ''
    },
    importTooltip () {
      batchCreateTooltip(this.tipData).then(response => {
        this.visible = false
        this.$message.success('Import success')
      })
    },
    exportTooltip () {
      listTooltip().then(response => {
        this.title = 'Export Tooltip'
        this.visible = true
        this.tipData = JSON.stringify(response)
      })
    },
    openChangeLog () {
      this.changeLogVisible = true
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  width: 100%;
  background-color: #fff;
  z-index: 99;
  border-radius: 0px !important;
  border-bottom: 1px solid #d8dce5;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left-title {
    height: 100%;
    line-height: 10px;
    font-size: 21px;
    display: flex;
    align-items: center;
  }
  .right-menu {
    height: 100%;
    margin-right: 10px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    cursor: pointer;
    &:focus {
      outline: none;
    }
    .zm-dropdown-link {
      font-size: 16px;
      margin-right: 16px;
      height: 32px;
      vertical-align: middle;
      span {
        font-size: 16px;
      }
    }
    ::v-deep .zm-avatar {
      background-color: #0e71ebcf;
    }
  }
}
.logo {
  height: 27px;
  padding-left: 20px;
  margin-right: 12px;
}
</style>
<style lang="scss">
.version-display-popper {
  word-wrap: break-word;
  white-space: pre-line;
}
.user-center-popver.zm-popper.zm-dropdown-menu {
  padding: 8px 12px;
  .zm-dropdown-menu__item {
    color: #0e71eb;
  }
  .user-name.zm-dropdown-menu__item {
    border-bottom: 1px solid #e8e9eb;
    color: #333;
    font-weight: bold;
  }
}
</style>
